<style>

::-webkit-scrollbar {
  width: 10px;
}

::-webkit-scrollbar-thumb {
  background: rgba(191, 188, 188, 0.6);
}

.required_err {
  color: rgba(255, 0, 0);
}

.elevation-1 tr:nth-of-type(even) {
    background-color: rgba(0, 0, 0, .03) !important;
}

.br {
    color: rgba(109, 103, 164);
}

</style>

<template>
<div class="ipv6_routes">
    <v-data-table
        :headers="headers"
        :items="items"
        :search="search"
        sort-by="prefix"
        class="elevation-1"
        @dblclick:row="on_dbl_click">

    <template v-slot:top>
        <v-toolbar flat>
            <v-toolbar-title><h2 class="br">IPv6 routes</h2></v-toolbar-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="600px">
            <div>
                <vif_box v-model="show_vif_form"
                    @canceled="on_vif_cancel" 
                    @selected="on_vif_select($event)">
                </vif_box>
            </div>
            <div>
                <ipv6_route_table_box v-model="show_ipv6_route_table_form"
                    @canceled="on_ipv6_route_table_form_cancel()"
                    @selected="on_ipv6_route_table_form_select($event)">
                </ipv6_route_table_box>
            </div>

            <template v-slot:activator="{ props }">
                <v-btn @click="new_item(item)"
                    color="primary" dark class="mb-2"
                    v-bind="props"
                    >
                    Add IP route
                </v-btn>
            </template>

            <ValidationObserver ref="observer" v-slot="{ invalid }"><v-card><v-form>
                <v-card-title>
                    <span class="headline">{{ form_title }}</span>
                </v-card-title>

                <v-card-text>
                    <v-container style="height: 520px; overflow-y: scroll;">
                        <v-row>

                    <v-col cols="12">
                        <ValidationProvider rules="required|ipv6_addr" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.prefix"
                                label="Prefix"
                            ></v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider rules="numeric|ipv6_mask" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.depth"
                                label="Mask"
                            ></v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider rules="required|rt_name" v-slot="{ errors }">
                            <v-text-field
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.rt_name"
                                label="Route table">
                                <template v-if="edited_index == -1" #append>
                                    <v-btn @click="open_ipv6_route_table_form()">...</v-btn>
                                </template>                          
                            </v-text-field>
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider rules="required" v-slot="{ errors }">
                            <v-combobox
                                v-bind:readonly="edited_index != -1"
                                v-model="edited_item.type"
                                label="Type"
                                :items="['Connected', 'Remote', 'Unreachable']"
                            ></v-combobox>                    
                            <span class="required_err">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <div v-if="edited_item.type.toLowerCase() === 'connected'">
                            <ValidationProvider rules="required" v-slot="{ errors }">
                                <v-text-field
                                    v-bind:readonly="edited_index != -1"
                                    v-model="edited_item.vif"
                                    label="VIF">
                                    <template v-if="edited_index == -1" #append>
                                        <v-btn @click="open_vif_form()">...</v-btn>
                                    </template>
                                </v-text-field>
                                <span class="required_err">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>

                        <div v-if="edited_item.type.toLowerCase() === 'remote'">
                            <v-data-table
                                :headers="nexthop_headers"
                                :items="nexthops"
                                sort-by="gw"
                                class="elevation-1"
                                @dblclick:row="on_nh_dbl_click">

                                <template v-slot:top>
                                    <v-toolbar flat>
                                        <v-toolbar-title>Next hops</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-dialog v-model="nexthop_dialog" max-width="500px">

                                        <template v-slot:activator="{ props }">
                                            <v-btn v-if="edited_index === -1" @click="new_nexthop(item)" v-bind="props">
                                                Add next hop
                                            </v-btn>
                                        </template>

                                        <ValidationObserver ref="nh_observer" v-slot="{ invalid }"><v-card><v-form>
                                            <v-card-title>
                                                <span class="headline">{{ nexthop_title }}</span>
                                            </v-card-title>

                                            <v-card-text>
                                                <v-container style="height: 520px; overflow-y: scroll;">
                                                    <v-row>
                                                <v-col cols="12">
                                                    <ValidationProvider rules="required|ipv6_addr" v-slot="{ errors }">
                                                        <v-text-field
                                                            v-model="edited_nexthop.gw"
                                                            label="Gateway IP address">
                                                        </v-text-field>
                                                        <span class="required_err">{{ errors[0] }}</span>
                                                    </ValidationProvider>

                                                    <ValidationProvider rules="numeric" v-slot="{ errors }">
                                                        <v-text-field
                                                            v-model="edited_nexthop.weight"
                                                            label="Weight (Optional)">
                                                        </v-text-field>
                                                        <span class="required_err">{{ errors[0] }}</span>
                                                    </ValidationProvider>
                                                </v-col>
                                                    </v-row>
                                                </v-container>
                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="blue darken-1" text @click="close_nh">
                                                    Cancel</v-btn>
                                                <v-btn color="blue darken-1" :disabled="invalid" text @click="save_nh">
                                                    Save</v-btn>
                                            </v-card-actions>
                                        </v-form></v-card></ValidationObserver>

                                        </v-dialog>
                                    </v-toolbar>   
                                </template>

                                <template v-slot:item.actions="{ item }" v-if="edited_index == -1">
                                    <v-icon small class="me-2" @click="edit_nh(item)">
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon small @click="delete_nh(item)">
                                        mdi-delete
                                    </v-icon>
                                </template>

                                <template v-slot:no-data>
                                </template>                                
                            </v-data-table>                          
                        </div>
                    </v-col>

                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                    <v-btn v-if="edited_index === -1" color="blue darken-1" 
                        :disabled="invalid" text @click="save">Save</v-btn>
                </v-card-actions>
            </v-form></v-card></ValidationObserver>

            </v-dialog>
        </v-toolbar>

        <v-toolbar flat>
            <v-combobox
                v-model="rt_name"
                label="Route table"
                :items="route_tables"
                @change="on_route_table_change()"
            ></v-combobox>
        </v-toolbar>        

        <v-toolbar flat>
            <v-text-field v-model="search"
                append-icon="mdi-magnify" label="Search" single-line hide-details
            ></v-text-field>
        </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
        <v-icon small class="me-2" @click="edit_item(item)">
            mdi-pencil
        </v-icon>
        <v-icon small @click="delete_item(item)">
            mdi-delete
        </v-icon>
    </template>

    <template v-slot:no-data>
    </template>

    </v-data-table>
</div>
</template>
  
<script>

import api_client from '../services/api.js';
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { ValidationProvider, extend } from 'vee-validate';
import { ValidationObserver } from 'vee-validate';
import { required, numeric } from 'vee-validate/dist/rules';
import vif_box from "../components/vif_box.vue";
import ipv6_route_table_box from "../components/ipv6_route_table_box.vue";
import "../validation_rules.js"

export default {
name: "ipv6_route",
components: { 
    Treeselect, ValidationProvider, ValidationObserver, vif_box,
    ipv6_route_table_box
},
data: () => ({
    show_vif_form: false,
    show_ipv6_route_table_form: false,
    
    rt_name: 'main6',
    route_tables: [],

    search: '',
    dialog: false,

    nexthop_dialog: false,
    edited_nexthop: {},
    edited_nh_index: -1,
    nexthops: [],
    nexthop_headers: [
        { text: 'Gateway', value: 'gw', align: 'start' },
        { text: 'Weight', value: 'weight' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],

    headers: [
        { text: 'Prefix', value: 'prefix', align: 'start' },
        { text: 'Mask', value: 'depth' },
        { text: 'Type', value: 'type' },
        { text: 'Proto', value: 'proto' },
        { text: 'VIF', value: 'vif' },
        { text: 'Gw', value: 'gw' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],
    items: [],
    edited_index: -1,
    edited_item: {
    },
    default_item: {
        prefix: '',
        depth: '',
        type: '',
        vif: '',
        rt_name: 'main6',
    },
}),

computed: {
    form_title() {
        return this.edited_index === -1 ? 'Add IPv6 route' : 'IPv6 route'
    },

    nexthop_title() {
        return this.edited_nh_index === -1 ? 'New nexthop' : 'Edit nexthop'    
    },
},

watch: {
},

created() {
    this.initialize()
},

methods: {
    on_vif_cancel() {
        this.show_vif_form = false;
    },

    on_vif_select(data) {
        this.edited_item.vif = data.name;
        this.show_vif_form = false;
    },

    open_vif_form() {
        this.show_vif_form = true;
    },

    on_ipv6_route_table_form_cancel() {
        this.show_ipv6_route_table_form = false;
    },

    on_ipv6_route_table_form_select(rt_name) {
        this.edited_item.rt_name = rt_name;
        this.show_ipv6_route_table_form = false;
    },

    open_ipv6_route_table_form() {
        this.show_ipv6_route_table_form = true;
    },

    load_routes(rt_name) {
        api_client.run_post_query('/ipv6_route/show', {"rt_name": rt_name})
        .then(response => {
            if (response.data.hasOwnProperty("err")) {
                this.$fire({title: "Command failed",
                    text: response.data.err, type: "warning"});
                return;
            }
            if (!response.data.hasOwnProperty("ipv6_routes")) {
                this.$fire({title: "Command failed",
                    text: "no ipv6 routes found in the response", type: "warning"});
                return;
            }
            this.items = response.data.ipv6_routes;
        })
        .catch(error => {
            console.log(error)
        });        
    },

    on_route_table_change() {
        this.load_routes(this.rt_name);
    },

    initialize() {
        // Load route tables
        api_client.sh_ipv6_route_tables()
        .then(response => {
            response.data.forEach(item => this.route_tables.push(item.rt_name));
        })
        .catch(error => {
            console.log(error)
        })

        // load routes
        this.rt_name = 'main6';
        this.load_routes(this.rt_name);
    },

    edit_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.edited_item.rt_name = this.rt_name;
        if (item.type === 'multihop') {
            this.nexthops = item.next_hops;
            this.edited_item.type = 'remote';
        }
        else if (item.type === 'via') {
            this.nexthops = [{
                "gw": item.gw,
            }];
            this.edited_item.type = 'remote';
        }
        this.dialog = true;
    },

    new_item() {
        requestAnimationFrame(() => {
            this.$refs.observer.reset();
        });          
        this.edited_index = -1;
        this.edited_item = Object.assign({}, this.default_item);
        this.edited_item.rt_name = this.rt_name;
        this.dialog = true;

        this.nexthops = [];
        this.edited_nh_index = -1;
        Object.assign(this.edited_nexthop, {});
        this.nexthop_dialog = false;
    },

    on_dbl_click(event, data) {
        this.edit_item(data.item);
    },

    close() {
        this.dialog = false;
        this.$nextTick(() => {
            this.edited_index = -1;
        });
    },

    delete_item(item) {
        this.edited_index = this.items.indexOf(item);
        this.edited_item = Object.assign({}, item);
        this.$confirm("Are you sure you want to delete IPv6 route " + 
            item.prefix + "/" + item.depth + "?")
        .then(() => {
            this.delete_item_confirm()
        });
    },

    delete_item_confirm() {
        api_client.run_post_query('ipv6_route/del', {
            prefix: this.edited_item.prefix,
            depth: this.edited_item.depth,
            rt_name: this.rt_name,
        })
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                return;
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
        this.items.splice(this.edited_index, 1);
    },

    add_route(prefix, depth, rt_name) {
        api_client.run_post_query('/ipv6_route/show_route', {
            prefix: prefix,
            depth: depth,
            rt_name: rt_name
        })
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                return;
            }
            else {
                this.items.push(response.data);
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    save_route(rt_type) 
    {
        if (this.edited_item.depth === '0') {
            this.$fire({title: "Command failed", text: 'Incorrect ipv6 mask', type: "warning"});
            return;
        }

        if (this.edited_item.prefix === '::') {
            this.$fire({title: "Command failed",
                text: ':: prefix can not be used with ' + rt_type + ' route type', type: "warning"});
            return;
        }

        let new_route = {
            prefix: this.edited_item.prefix,
            depth: this.edited_item.depth,
            rt_name: this.edited_item.rt_name,
            rt_type: rt_type,
        };

        api_client.run_post_query('/ipv6_route/add', new_route)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                /* success */
                this.add_route(new_route.prefix, new_route.depth, new_route.rt_name);
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });        
    },

    save_connected_route()
    {
        if (this.edited_item.depth === '0') {
            this.$fire({title: "Command failed", text: 'Incorrect ipv6 mask', type: "warning"});
            return;
        }

        if (this.edited_item.prefix === '::') {
            this.$fire({title: "Command failed",
                text: ':: route can not be a connected route', type: "warning"});
            return;
        }

        let new_route = {
            prefix: this.edited_item.prefix,
            depth: this.edited_item.depth,
            vif: this.edited_item.vif,
            rt_name: this.edited_item.rt_name,
        };

        api_client.run_post_query('/ipv6_route/add_connected', new_route)
        .then(response => {
            if (response.data.hasOwnProperty("err_msg")) {
                this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
            }
            else {
                /* success */
                this.add_route(new_route.prefix, new_route.depth, new_route.rt_name);
                this.close();
            }
        })
        .catch(error => {
            console.log(error);
            this.$fire({title: "Command failed", text: error, type: "warning"});
        });
    },

    save_remote_route() {
        if (this.nexthops.length === 0) {
            this.$fire({title: "Command failed",
                text: 'At least one next hop should be added.', type: "warning"});
            return;
        }

        let new_route = {
            prefix: this.edited_item.prefix,
            depth: this.edited_item.depth,
            rt_name: this.edited_item.rt_name,
        };

        if (this.nexthops.length === 1) {
            new_route["gw"] = this.nexthops[0]["gw"];

            api_client.run_post_query('ipv6_route/add_single_hop', new_route)
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    /* success */
                    this.add_route(new_route.prefix, new_route.depth, new_route.rt_name);
                    this.close();
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        }
        else {
            let i;
            let nh;

            new_route["nexthops"] = [];
            for (i = 0; i < this.nexthops.length; i++) {
                nh = {};
                nh["gw"] = this.nexthops[i]["gw"];
                if (this.nexthops[i]["weight"] != '') {
                    nh["weight"] = this.nexthops[i]["weight"];
                }
                new_route["nexthops"].push(nh);
            }

            api_client.run_post_query('ipv6_route/add_multi_hop', new_route)
            .then(response => {
                if (response.data.hasOwnProperty("err_msg")) {
                    this.$fire({title: "Command failed", text: response.data.err_msg, type: "warning"});
                }
                else {
                    /* success */
                    this.add_route(new_route.prefix, new_route.depth, new_route.rt_name);
                    this.close();
                }
            })
            .catch(error => {
                console.log(error);
                this.$fire({title: "Command failed", text: error, type: "warning"});
            });
        }
    },

    save() {
        let rt_type = this.edited_item.type.toLowerCase();

        if (rt_type === 'connected') {
            this.save_connected_route();
        }
        else if (rt_type === 'unreachable') {
            this.save_route(rt_type);
        }
        else if (rt_type === 'remote') {
            this.save_remote_route();
        }
    },

    new_nexthop() {
        requestAnimationFrame(() => {
            this.$refs.observer.reset();
        });
        this.edited_nh_index = -1;
        this.edited_nexthop = {
            "gw": '',
            "weight": '',
        };
        this.nexthop_dialog = true;
    },

    close_nh() {
        this.nexthop_dialog = false;
        this.$nextTick(() => {
            this.edited_nh_index = -1;
        });
    },

    save_nh() {
        if (this.edited_nh_index === -1) {
            this.nexthops.push(this.edited_nexthop);
        }
        else {
            Object.assign(this.nexthops[this.edited_nh_index], this.edited_nexthop);
        }
        this.close_nh();
    },

    edit_nh(item) {
        this.edited_nh_index = this.nexthops.indexOf(item);
        this.edited_nexthop = Object.assign({}, item);
        this.nexthop_dialog = true;
    },
    
    delete_nh(item) {
        this.edited_nh_index = this.nexthops.indexOf(item);
        this.edited_nexthop = Object.assign({}, item);
        this.$confirm("Are you sure you want to delete nexthop  " + 
            item.gw + "?")
        .then(() => {
            this.nexthops.splice(this.edited_nh_index, 1);
        });
    },

    on_nh_dbl_click(event, data) {
        if (this.edited_index != -1)
            return;
        this.edit_nh(data.item);
    },    
}

};
</script>
